import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {ReceivablesBalance} from "../../interface/receivables-balance";
import {TerminalsImportRow} from "../../interface/terminals-import-row";
import {ReplaySubject} from "rxjs";
import {ListResponse} from "../../interface/response/list-response";
import {ReceivablesBalanceService} from "../../services/receivables-balance.service";
import {TerminalsImportRowService} from "../../services/terminals-import-row.service";
import {debounceTime, distinctUntilChanged, startWith, takeUntil} from "rxjs/operators";
import {MatSelectChange} from "@angular/material/select";
import {TERMINALS_IMPORT_ROW_STATUS_UNSETTLED} from "../../services/dict.service";

@Component({
  selector: 'app-dict-terminal-import-row',
  templateUrl: './dict-terminal-import-row.component.html',
  styleUrls: ['./dict-terminal-import-row.component.scss'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => DictTerminalImportRowComponent)}
  ]
})
export class DictTerminalImportRowComponent implements  OnInit, OnDestroy, ControlValueAccessor {

  @Input() label: string;
  @Input() multiple = false;
  @Input() control: FormControl = null;
  @Input() required = false;
  @Input() partnerId?: string;
  @Input() receivablesBalanceItems: TerminalsImportRow[] = null;
  @Output() selected: EventEmitter<TerminalsImportRow> = new EventEmitter<TerminalsImportRow>();

  externalControl = true;
  items: TerminalsImportRow[] = [];
  disabled = false;
  value?: string = null;
  terminalsImportRowFilterCtrl: FormControl;
  itemsSubject: ReplaySubject<ListResponse<TerminalsImportRow>> = new ReplaySubject<ListResponse<TerminalsImportRow>>(1);

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private terminalsImportRowService: TerminalsImportRowService,
    private fb: FormBuilder,
  ) {
    this.terminalsImportRowFilterCtrl = fb.control('');
  }

  onChange: any = () => { };
  onTouched: any = () => { };


  ngOnInit(): void {

    if ( this.receivablesBalanceItems !== null) {
      this.items = this.receivablesBalanceItems;
    }
    if (this.control === null) {
      this.control = new FormControl('');
      this.externalControl = false;
    }

    this.control.valueChanges
      .pipe(
        startWith(this.control.value),
        takeUntil(this.destroyed$)
      )
      .subscribe((val: string) => {
        if (val) {
          let exists = false;
          this.items.forEach((terminalsImportRow: TerminalsImportRow) => {
            if (terminalsImportRow.uuid === val) {
              exists = true;
            }
          });

          if (!exists) {
            this.terminalsImportRowService.loadNotCountedList(0, 9999, {
              in$id: val,
              partner: this.partnerId
            }, this.itemsSubject);
          }
        }
      });

    this.itemsSubject
      .pipe(takeUntil(this.destroyed$))
      .subscribe((result: ListResponse<TerminalsImportRow>) => {
        if ( this.receivablesBalanceItems === null) {
          this.items = result.items;
        } else{
          this.items = this.receivablesBalanceItems;
        }
      });

    this.terminalsImportRowFilterCtrl.valueChanges
      .pipe(
        debounceTime(200),
        distinctUntilChanged(),
        takeUntil(this.destroyed$)
      )
      .subscribe((val) => {
        if (val) {
          this.terminalsImportRowService.loadNotCountedList(0, 5, {
            contains$id: val,
            statusKey: TERMINALS_IMPORT_ROW_STATUS_UNSETTLED,
            partner: this.partnerId
          }, this.itemsSubject);
        } else if (this.control.value) {
          this.terminalsImportRowService.loadNotCountedList(0, 9999, {
            in$id: this.control.value,    partner: this.partnerId
          }, this.itemsSubject);
        }
      });
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }


  setDisabledState(isDisabled: boolean): void {
    if (this.externalControl) {
      return;
    }

    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }

    this.disabled = isDisabled;
  }

  writeValue(value: any): void {
    if (this.externalControl) {
      return;
    }

    this.control.setValue(value);
    this.value = value;
  }

  onSelectionChange(e: MatSelectChange): void {
    this.items.forEach((terminalsImportRow: TerminalsImportRow) => {
      if (terminalsImportRow.uuid === e.value) {
        this.selected.emit(terminalsImportRow);
      }
    });

    this.value = e.value;
    this.onChange(this.value);
  }

  clearValue(): void {
    this.control.setValue(this.multiple ? [] : '');
    this.writeValue(this.multiple ? [] : '');
    this.onChange(this.value);
    this.selected.emit();
  }

}
